class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    super.connectedCallback?.();
    if (!this.mainDetailsToggle) this.mainDetailsToggle = this.querySelector('details');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    const toggle = this.mainDetailsToggle?.querySelector('summary .header__menu-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', this.mainDetailsToggle.hasAttribute('open'));

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// Parent link + toggle behavior for desktop header menus (not mobile drawer — MenuDrawer handles those)
document.addEventListener('click', (e) => {
  const parentLink = e.target.closest('.header__menu-parent-link');
  const toggle = e.target.closest('.header__menu-toggle');
  const summary = e.target.closest('summary');
  const inMenuDrawer = summary?.closest('header-drawer, menu-drawer');

  if (parentLink && summary && summary.contains(parentLink)) {
    if (summary.closest('header-drawer, menu-drawer')) {
      e.preventDefault();
    } else {
      e.preventDefault();
      e.stopPropagation();
      const details = summary.closest('details');
      const menuToggle = summary.querySelector('.header__menu-toggle');
      if (details) {
        details.toggleAttribute('open');
        if (menuToggle) menuToggle.setAttribute('aria-expanded', details.hasAttribute('open'));
      }
    }
  }

  if (toggle && summary && summary.contains(toggle)) {
    if (inMenuDrawer) return;

    e.preventDefault();
    e.stopPropagation();
    const details = summary.closest('details');
    if (details) {
      details.toggleAttribute('open');
      toggle.setAttribute('aria-expanded', details.hasAttribute('open'));
    }
  }
}, true);

document.addEventListener('keydown', (e) => {
  const parentLink = e.target.closest('.header__menu-parent-link');
  const toggle = e.target.closest('.header__menu-toggle');
  if (e.key !== 'Enter' && e.key !== ' ') return;

  if (parentLink) {
    const summary = parentLink.closest('summary');
    if (summary?.closest('header-drawer, menu-drawer')) return;

    e.preventDefault();
    const details = summary?.closest('details');
    const menuToggle = summary?.querySelector('.header__menu-toggle');
    if (details) {
      details.toggleAttribute('open');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', details.hasAttribute('open'));
    }
    return;
  }

  if (!toggle) return;

  const summary = toggle.closest('summary');
  if (summary?.closest('header-drawer, menu-drawer')) {
    e.preventDefault();
    summary.click();
    return;
  }

  e.preventDefault();
  const details = summary?.closest('details');
  if (details) {
    details.toggleAttribute('open');
    toggle.setAttribute('aria-expanded', details.hasAttribute('open'));
  }
}, true);
